/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export const COOKIE_EXPIRATION_DAYS = 365 * 3;
export const COOKIE_URL_TRACKER_ENTRIES_LIMIT = 20;
export const COOKIE_URL_TRACKER_NAME = 'url-tracker';
